import { LIST_ITEM_QUERY_PARAM } from '../constants';
const placeholderBase = 'https://blazecms.app'; // placeholder for URL, removed later

const setParamAndRedirect = (router, value) => {
  const currentUrl = new URL(router.asPath, placeholderBase);
  if (value) {
    currentUrl.searchParams.set(LIST_ITEM_QUERY_PARAM, value);
  } else if (!currentUrl.searchParams.get(LIST_ITEM_QUERY_PARAM)) return;else {
    currentUrl.searchParams.delete(LIST_ITEM_QUERY_PARAM);
  }
  const newUrl = currentUrl.toString().replace(placeholderBase, '');
  router.push('/Resolver', newUrl, {
    shallow: true
  });
};
export default setParamAndRedirect;
//# sourceMappingURL=set-param-and-redirect.js.map